import * as API from '../api'
import { toProfileState } from '../utils/handleProfileApiData'

export const ADD_PROFILE = 'ADD_PROFILE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_PROFILE = 'CHANGE_PROFILE'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const DELETE_PROFILE = 'DELETE_PROFILE'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const FETCH_FUNCTIONALITIES = 'FETCH_FUNCTIONALITIES'
export const FETCH_FUNCTIONALITIES_ERROR = 'FETCH_FUNCTIONALITIES_ERROR'
export const FETCH_PROFILE = 'FETCH_PROFILE'
export const FETCH_PROFILE_ERROR = 'FETCH_PROFILE_ERROR'
export const FETCH_PROFILES = 'FETCH_PROFILES'
export const FETCH_PROFILES_ERROR = 'FETCH_PROFILES_ERROR'
export const FETCHING_FUNCTIONALITIES = 'FETCHING_FUNCTIONALITIES'
export const FETCHING_PROFILE = 'FETCHING_PROFILE'
export const FETCHING_PROFILES = 'FETCHING_PROFILES'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_PROFILE = 'NEW_FORM_PROFILE'
export const OPEN_MODAL = 'OPEN_MODAL'
export const PROFILE_FORM_ERROR = 'PROFILE_FORM_ERROR'
export const RESET_STATE = 'RESET_STATE'
export const CHANGE_PERMISSIONS = 'CHANGE_PERMISSIONS'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeProfile = profile => {
  return dispatch => {
    dispatch({ type: CHANGE_PROFILE, profile })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

const getInvalidField = errorMessage => {
  const [x, field = ''] = /validation failed: (.*):/.exec(errorMessage) || [] // eslint-disable-line
  return field
}

export const handleProfileError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({ type: FORM_TOUCHED })

      dispatch({
        type: PROFILE_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })

      return Promise.reject(res)

    case errorMessage.includes('validation failed'):
      dispatch({ type: FORM_TOUCHED })

      dispatch({
        type: PROFILE_FORM_ERROR,
        field: getInvalidField(errorMessage),
        message: `${getInvalidField(errorMessage)} é inválido.`
      })

      return Promise.reject(res)

    default:
      break
  }
}

export const newFormProfile = profile => {
  return dispatch => {
    dispatch({ type: NEW_FORM_PROFILE })
  }
}

export const setProfileFormTouched = profile => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreProfile = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILES })

    return API.profiles
      .restoreProfile(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_PROFILE, profile: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PROFILES_ERROR,
          err: message || 'Serviço indisponível'
        })

        handleProfileError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchProfiles = options => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILES })

    return API.profiles
      .getProfiles(options)
      .then((res = {}) => {
        const { data } = res

        dispatch({
          type: FETCH_PROFILES,
          profiles: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PROFILES_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const fetchFunctionalities = () => {
  return dispatch => {
    dispatch({ type: FETCHING_FUNCTIONALITIES })

    return API.profiles
      .getFunctionalities()
      .then((res = {}) => {
        const { data: functionalities } = res

        dispatch({
          type: FETCH_FUNCTIONALITIES,
          functionalities
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_FUNCTIONALITIES_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const deleteProfile = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILES })

    return API.profiles
      .deleteProfile(id)
      .then(response => {
        const { data = {} } = response

        dispatch({ type: DELETE_PROFILE, profile: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PROFILES_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const addProfile = profile => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILES })
    dispatch({ type: FETCHING_PROFILE })

    return API.profiles
      .addProfile(profile)
      .then(({ data }) => {
        dispatch({ type: ADD_PROFILE, profile: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        handleProfileError(response, dispatch)

        dispatch({
          type: FETCH_PROFILES_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const editProfile = profile => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILES })
    dispatch({ type: FETCHING_PROFILE })

    return API.profiles
      .editProfile(profile)
      .then(({ data }) => {
        dispatch({ type: EDIT_PROFILE, profile: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PROFILES_ERROR,
          err: message || 'Serviço indisponível'
        })

        handleProfileError(response, dispatch)

        return Promise.reject(response)
      })
  }
}

export const fetchProfile = id => {
  return dispatch => {
    dispatch({ type: FETCHING_PROFILE, clear: true })
    dispatch({ type: OPEN_MODAL })

    return API.profiles
      .getProfile(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_PROFILE, profile: toProfileState(data) })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data

        dispatch({
          type: FETCH_PROFILE_ERROR,
          err: message || 'Serviço indisponível'
        })

        return Promise.reject(err)
      })
  }
}

export const handlePermissionsChange = permission => {
  return dispatch => {
    dispatch({
      type: CHANGE_PERMISSIONS,
      permission
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/profiles.js